import "./Button.css";

// Ein Knopf, vier Varianten. Dazu kommt die STOPP-Flaeche (Stopp.jsx).
export const BUTTON_VARIANTEN = {
  haupt: "knopf haupt",
  neben: "knopf neben",
  text: "knopf text",
  hell: "knopf hell",
};

/**
 * Knopf mit Variante: haupt = gruene Hauptaktion (genau eine pro
 * Bildschirm), neben = Nebenaktion, text = leise Textaktion, hell = weiss
 * (Loesung aufdecken). Alle weiteren Props gehen an das <button>.
 * @category bausteine
 */
export function Button({ variant = "haupt", className, children, ...rest }) {
  const klassen = [BUTTON_VARIANTEN[variant] || BUTTON_VARIANTEN.haupt, className].filter(Boolean).join(" ");
  return (
    <button type="button" className={klassen} {...rest}>
      {children}
    </button>
  );
}

export default Button;
